<template>
	<div class="h-full">
		<div class="pt-4 sm:pt-8 lg:pt-16 pb-16 space-y-8">
			<div class="px-2 md:px-8 lg:px-16 text-left">
				<div class="text-left">
					<div
						class="text-vc-title-sm md:text-vc-title-md"
						style="font-family: Gascogne Serial Medium; line-height: 1"
					>
						Club Chidos
					</div>
					<div style="font-size: 24px; line-height: 1.2">
						<span class="text-primary"> Descubre el mundo del vino y crea comunidad </span>
						<span class="text-gray"> con gente chida como tú. </span>
					</div>
					<div class="text-vc-header-xl sm:text-vc-title-sm w-full text-left pt-2">
						<div class="relative h-60 sm:h-72 md:h-96 rounded-2xl overflow-hidden">
							<img
								src="https://res.cloudinary.com/de8bjjxg0/image/upload/v1737653808/Club-Header.jpg"
								alt="Club Header"
								class="w-full h-full object-cover"
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="px-2 md:px-8 lg:px-16">
				<div class="text-vc-header-xl pb-2">¿Qué es un vino chido?</div>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-2">
					<TextPhotoBubbleComponent :data="views.historia" />
					<TextPhotoBubbleComponent :data="views.descubrir" />
				</div>
			</div>

			<div class="">
				<div class="px-2 md:px-8 lg:px-16 text-vc-header-xl pb-2">Conoce los Clubs</div>
				<div
					class="px-2 md:px-8 lg:px-16 sm:flex flex-row space-x-0 sm:space-x-2 overflow-x-scroll grid grid-cols-2 sm:grid-rows-1 gap-2 sm:gap-0"
				>
					<ClubComponent
						:data="clubs.clubExplorer"
						:show-button="true"
						:tag="true"
						:handler="checkoutClub"
					/>
					<ClubComponent
						:data="clubs.clubBold"
						:show-button="true"
						:tag="true"
						:handler="checkoutClub"
					/>
					<ClubComponent
						:data="clubs.clubBright"
						:show-button="true"
						:tag="true"
						:handler="checkoutClub"
					/>
					<ClubComponent
						:data="clubs.clubFearless"
						:show-button="true"
						:tag="true"
						:handler="checkoutClub"
					/>
				</div>
			</div>

			<div class="px-2 md:px-8 lg:px-16">
				<div class="text-vc-header-xl pb-2">Beneficios</div>
				<ul class="list-disc list-inside">
					<li>Portal con notas de cata, maridajes y más</li>
					<li>Acceso a Wine & Friends</li>
					<li>Acceso a Deep Dive</li>
					<li>⁠Descuento en botellas: 10% a partir de 1 botella, 15% a partir de 5.</li>
				</ul>
				<!-- <div class="border-primary border-2 rounded-2xl divide-primary divide-y-2">
					<div class="grid grid-cols-3 divide-primary divide-x-2 font-bold">
						<div class="p-2">Beneficio</div>
						<div class="p-2">Explorer, Bold, y Bright</div>
						<div class="p-2">Fearless</div>
					</div>
					<div class="grid grid-cols-3 divide-primary divide-x-2">
						<div class="p-2">Notas de cata</div>
						<div class="p-2">¡Si!</div>
						<div class="p-2">¡Si!</div>
					</div>
					<div class="grid grid-cols-3 divide-primary divide-x-2">
						<div class="p-2">Cata Chidas</div>
						<div class="p-2">¡Si!</div>
						<div class="p-2">¡Si!</div>
					</div>
					<div class="grid grid-cols-3 divide-primary divide-x-2">
						<div class="p-2">Acompañante gratis</div>
						<div class="p-2"></div>
						<div class="p-2">¡Si!</div>
					</div>
					<div class="grid grid-cols-3 divide-primary divide-x-2">
						<div class="p-2">Descuento en tiendas</div>
						<div class="p-2">10% en una botella</div>
						<div class="p-2">15% en una botella</div>
					</div>
				</div> -->
			</div>

			<TextPhotoSectionComponent
				:data="{
					title: 'Sólo necesitas de vino y gente chida.',
					text: 'De miércoles a sábado en nuestros speakeasy\'s, creamos un espacio para que pruebes vinos ricos acompañados de gente chida como tú.',
					color: 'blue',
					image: 'https://res.cloudinary.com/de8bjjxg0/image/upload/v1737653834/Club-GenteChida.jpg'
				}"
			/>

			<div class="px-2 md:px-8 lg:px-16">
				<div class="text-vc-header-xl pb-2">Nuestro proceso</div>
				<div class="grid grid-cols-2 gap-2">
					<TextPhotoComponent :data="textPhotos[0]" />
					<TextPhotoComponent :data="textPhotos[1]" />
				</div>
				<div class="grid grid-cols-2 pt-2 gap-2">
					<TextPhotoComponent :data="textPhotos[2]" />
					<TextPhotoComponent :data="textPhotos[3]" />
				</div>
			</div>

			<div class="px-2 md:px-8 lg:px-16">
				<div class="text-vc-header-xl pb-2">Preguntas frecuentes</div>
				<div class="text-vc-small pt-4">
					<details
						v-for="pregunta in preguntas"
						:key="pregunta.titulo"
						class="pb-4"
					>
						<summary class="pl-2">{{ pregunta.titulo }}</summary>
						<div class="pt-2 pl-6">
							{{ pregunta.texto }}
						</div>
					</details>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'

import ClubComponent from '@/components/ClubComponent.vue'
import TextPhotoComponent from '@/components/TextPhotoComponent.vue'
import TextPhotoSectionComponent from '@/components/TextPhotoSectionComponent.vue'
import TextPhotoBubbleComponent from '@/components/TextPhotoBubbleComponent.vue'
import data from '../assets/data'
import { useHead } from '@vueuse/head'

export default {
	name: 'HomeView',
	components: {
		ClubComponent,
		TextPhotoComponent,
		TextPhotoBubbleComponent,
		TextPhotoSectionComponent
	},
	setup() {
		useHead({
			title: 'Club Chidos - Vino Chido para Gente Chida',
			meta: [
				{
					name: 'description',
					content:
						'Únete al Club Chidos y descubre el mundo del vino con gente chida como tú. Accede a experiencias exclusivas, notas de cata, descuentos especiales y una comunidad apasionada por el vino.'
				},
				{ property: 'og:title', content: 'Club Chidos - Vino Chido para Gente Chida' },
				{
					property: 'og:description',
					content:
						'Únete al Club Chidos y descubre el mundo del vino con gente chida como tú. Accede a experiencias exclusivas, notas de cata, descuentos especiales y una comunidad apasionada por el vino.'
				},
				{
					property: 'og:image',
					content: 'https://res.cloudinary.com/de8bjjxg0/image/upload/v1737653808/Club-Header.jpg'
				},
				{ property: 'og:type', content: 'website' },
				{
					name: 'keywords',
					content:
						'club de vino, catas de vino, comunidad de vino, vinos en México, club de vinos chidos'
				}
			]
		})

		const router = useRouter()

		const clubs = data.clubs

		const textPhotos = [
			{
				title: 'Empezamos en el viñedo',
				text: 'Viajamos para elegir los vinos más chidos, empezamos por conocer las bodegas desde su filosofía y su entorno para asegurar que compartan nuestra pasión.',
				image:
					'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653833/Club-Vi%C3%B1edo.jpg'
			},
			{
				title: 'Conocemos al productor',
				text: 'Visitamos a cada productor para conocer su voz e inspiración. Empacamos y los dejamos listos para viajar internacionalmente.',
				image:
					'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653831/Club-Productores.jpg'
			},
			{
				title: 'Te lo contamos chido ',
				text: 'Recopilamos toda la información y te la resumimos con recomendaciones para que puedas aplicar el conocimiento a tu vida diaria.',
				image:
					'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653834/Club-Contamos.jpg'
			},
			{
				title: 'Te mandamos tus vinos!',
				text: 'El equipo prepara y manda tus vinos con cuidado para que emocione cada entrega.',
				image: 'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653835/Club-Envio.jpg'
			}
		]

		const views = {
			historia: {
				title: 'El que cuenta una historia',
				photo:
					'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653831/Club-Historia.jpg',
				text: 'Sin químicos ni modificaciones, el vino puede contarnos de dónde viene tal y como es, sin filtros.',
				right: false
			},
			descubrir: {
				title: 'El que te sorprende',
				photo:
					'https://res.cloudinary.com/de8bjjxg0/image/upload/q_auto/v1737653833/Club-Sorprende.jpg',
				text: '¡Es imposible que nos guste todo! Cada copa te llevará un paso más cerca a que descubras tu vino favorito.',
				right: true
			}
		}

		const preguntas = [
			{
				titulo: '¿Qué incluye mi suscripción?',
				texto:
					'Todos los Clubs de Vinos Chidos incluyen desde dos a seis vinos dependiendo de la suscripción.'
			},
			{
				titulo: 'Además de mis vinos, ¿qué más incluye mi suscripción?',
				texto:
					'Siempre tienes acceso a un portal exclusivo donde viven tus notas de cata, así como acceso a todas las experiencias (Wine & Friends, Deep Dive, Bar de Vinos Chidos). También siempre tienes descuento en tiendas desde una botella.'
			},
			{
				titulo: '¿Cómo funciona el cobro?',
				texto:
					'Cada mes cobramos automáticamente a tu tarjeta domiciliada. Tu cargo será el mismo día que te inscribiste. Por ejemplo, si te inscribes el 10 de mayo, tu próximo cargo sería el 10 de junio. Puedes hacer cambio en tu fecha de cobro cuando lo necesites.'
			},
			{
				titulo: '¿Cuándo llegan mis vinos?',
				texto:
					'Tus vinos llegarán en el lapso de dos días después de tu cargo mensual (de lunes a viernes). Si no hay quien pueda recibirlos, puedes elegir hacer pickup en la tienda que más te convenga. En caso de que vivas fuera de CDMX, tus vinos llegarán en 4-6 días hábiles. ¡Entregamos a toda la República!'
			},
			{
				titulo: '¿Cuál es la política de cancelación?',
				texto:
					'Puedes cancelar en cualquier momento, pero una vez que cobramos no hacemos reembolsos.'
			}
		]

		function checkoutClub(data) {
			router.push(`/checkout?slug=${data.slug}`)
		}

		return {
			clubs,
			checkoutClub,
			textPhotos,
			views,
			preguntas
		}
	}
}
</script>
